import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-portfolio',
  templateUrl: './web-portfolio.component.html',
  styleUrls: ['./web-portfolio.component.scss']
})
export class WebPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
